export const SET_POSTS_COUNT = "SET_POSTS_COUNT";
export const SET_THREAD_NAME = "SET_THREAD_NAME";
